import { fetchRequest, errorUtil } from '@app/util'

const query = `mutation OrganizationRoleAssignMulti($organization: ID!, $roles: [RoleAssignInput!]!) {
  organizationRoleAssignMulti(organization: $organization, roles: $roles) {
    id
  }
}`

async function requestOrganizationRoleAssign (variables, token) {
  const response = await fetchRequest({ query, variables, token })
  if (!response) return errorUtil.noResponse()

  const { errors, data } = await response
  if (errors) {
    return errorUtil.apiError('organization', errors)
  }
  return data.organizationRoleAssignMulti
}

export default requestOrganizationRoleAssign
